

<ng-template #errorTemplate></ng-template>

@if (templateDetails$ | async; as templateDetails) {
  <div class="template-details-container">
    <!-- Template Information -->
    <div class="info-section">
      <app-template-information
        (isEditing)="onEdit($event)"
        [templateDetails]="templateDetails"
        [sysText]="sysText.templateDetails"
        [unsavedChangesSysText]="sysText.unsavedChanges">
      </app-template-information>
    </div>
    <!-- Assigned Employers -->
    @if (templateDetails.showAssignedEmployers) {
      <div class="info-section">
        <app-assigned-employers
          (isEditing)="onEdit($event)"
          [mode]="assignEmployersMode.EmailTemplate"
          [canEditEmployers]="templateDetails.canEditEmployers"
          [id]="templateDetails.id"
          [employers]="templateDetails.employers"
          [sysText]="sysText.templateDetails"
          [unsavedChangesSysText]="sysText.unsavedChanges">
        </app-assigned-employers>
      </div>
    }
    <!-- Email Content -->
    <div class="info-section">
      <app-template-email-content
        (isEditing)="onEdit($event)"
        [templateDetails]="templateDetails"
        [sysText]="sysText.templateDetails"
        [unsavedChangesSysText]="sysText.unsavedChanges">
      </app-template-email-content>
    </div>
    <!-- Template Documents -->
    <div class="info-section">
      <app-template-attached-documents
        (isEditing)="onEdit($event)"
        [templateDetails]="templateDetails"
        [documents]="templateDetails.documents"
        [sysText]="sysText.templateDetails"
        [templateId]="templateDetails.id"
        [uploadDocSysText]="sysText.uploadDocumentDialog"
        [unsavedChangesSysText]="sysText.unsavedChanges">
      </app-template-attached-documents>
    </div>
    <!-- Buttons -->
    @if (templateDetails.showAssignToEmployer) {
      <div class="bottom-section">
        <!-- one button whose label follows the assignment, so focus stays on it when that changes. while saving it keeps
        focus: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
        @let isSubmitting = isSubmitting$ | async;
        @let assigned = templateDetails.assignedToEmployer;
        <button
          mat-flat-button
          [color]="assigned ? 'warn' : 'accent'"
          class="button bottom-button"
          [disabled]="isSubmitting"
          disabledInteractive
          [showProgress]="isSubmitting"
          [attr.aria-label]="isSubmitting ? sysText.templateDetails.submitting_ariaLabel : null"
          (click)="!isSubmitting && (assigned ? unassignEmployer() : assignEmployer())">
          {{ (assigned ? 'Unassign My Employer' : 'Assign My Employer') | uppercase }}
          <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
        </button>
      </div>
    }
  </div>
} @else {
  <div class="spinner-container">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
